import * as complaintTypes from '../types/Complaint';
import { INITIAL_STATE } from './state/Complaint';
import * as pageTypes from '../types/Page';
import moment from 'moment'; 
import {THROW_ERROR} from '../types/Error';
export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case THROW_ERROR:
        case complaintTypes.COMPLAINT_ISSUE_COMPLAINT_FAILURE:
        case complaintTypes.COMPLAINT_ISSUE_COMPLAINT_SUCCESS:
            return{
                ...state,
                isIssuing: false
            };
        case complaintTypes.COMPLAINT_ISSUE_COMPLAINT_REQUEST:

            return{
                ...state,
                isIssuing: true
            };
        case complaintTypes.COMPLAINT_CHANGE_COMPLAINT_TYPE:
        case complaintTypes.COMPLAINT_CHANGE_TERM_OF_USE_VALUE:
            return Object.assign({}, state, action.payload);
        case complaintTypes.COMPLAINT_SEARCH_COMPLAINT_SUCCESS:
            return {
                ...state,
                complaintType: action.payload.complaintHeader.complaintType,
                password: '',
                createDate: moment(action.payload.complaintHeader.createDate),
                erpStatus:action.payload.complaintHeader.erpStatus,
                notes: action.payload.complaintHeader.notes
            };    
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return INITIAL_STATE;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Complaint.js